/**
 * ODDFISH MEDIA — Our Agency Page Animations
 * Matches live oddfishmedia.com.au/our-agency/ scroll + slick behaviour
 */

(function () {
  "use strict";

  function initAos() {
    if (typeof AOS === "undefined") return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    if (!window.__oddfishAosInit) {
      AOS.init({
        once: true,
        duration: 800,
        easing: "ease-out-cubic",
        offset: 120
      });
      window.__oddfishAosInit = true;
    } else {
      AOS.refresh();
    }
  }

  function initBelieveBlocks(page) {
    var believe = page.querySelector(".believe_in_sections");
    if (!believe) return;

    believe.querySelectorAll("[data-aos]").forEach(function (el) {
      if (el.dataset.believeAosBound === "1") return;
      el.dataset.believeAosBound = "1";

      if (!("IntersectionObserver" in window)) {
        el.classList.add("aos-animate");
        return;
      }

      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add("aos-animate");
            }
          });
        },
        { threshold: 0.2, rootMargin: "0px 0px -10% 0px" }
      ).observe(el);
    });
  }

  function initAgencyPage() {
    var page = document.querySelector(".oddfish-agency-page");
    if (!page) return;

    initAos();
    initBelieveBlocks(page);

    if (!page.dataset.oddfishAgencyBound) {
      page.dataset.oddfishAgencyBound = "true";

      var ticking = false;
      window.addEventListener("scroll", function () {
        if (!ticking) {
          requestAnimationFrame(function () {
            handleScroll(page);
            ticking = false;
          });
          ticking = true;
        }
      }, { passive: true });

      page.querySelectorAll(".strike_btn").forEach(function (btn) {
        if (btn.dataset.oddfishStrikeBound) return;
        btn.dataset.oddfishStrikeBound = "true";
        btn.addEventListener("mouseenter", function () {
          btn.classList.add("strike-visible");
        });
        btn.addEventListener("mouseleave", function () {
          btn.classList.remove("strike-visible");
        });
      });
    }

    handleScroll(page);
    initClientsSlider(page);
  }

  function handleScroll(page) {
    var windowBottom = window.scrollY + window.innerHeight;

    page.querySelectorAll(".animate").forEach(function (section) {
      var sectionBottom = section.offsetTop + section.offsetHeight - 50;

      if (windowBottom > sectionBottom) {
        section.classList.add("scrolled");

        section.querySelectorAll(".strike").forEach(function (el) {
          el.classList.add("strike-visible");
        });
      }
    });
  }

  function initClientsSlider(page) {
    var slider = page.querySelector(".clients_slider");
    if (!slider) return;

    function tryInit(attempt) {
      if (typeof jQuery === "undefined" || !jQuery.fn || !jQuery.fn.slick) {
        if (attempt < 60) {
          window.setTimeout(function () {
            tryInit(attempt + 1);
          }, 100);
        }
        return;
      }

      var $slider = jQuery(slider);

      if ($slider.hasClass("slick-initialized")) {
        $slider.slick("unslick");
      }

      var prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

      $slider.slick({
        dots: true,
        arrows: false,
        infinite: true,
        autoplay: !prefersReducedMotion,
        autoplaySpeed: 1500,
        pauseOnHover: true,
        pauseOnFocus: true,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 5,
        accessibility: true,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4
            }
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3
            }
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              dots: false
            }
          },
          {
            breakpoint: 501,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding: "40px",
              dots: false
            }
          }
        ]
      });
    }

    tryInit(0);
  }

  function boot() {
    initAgencyPage();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  window.addEventListener("load", boot);

  document.addEventListener("shopify:section:load", function (e) {
    var page = e.target.querySelector(".oddfish-agency-page");
    if (!page) return;
    delete page.dataset.oddfishAgencyBound;
    boot();
  });
})();
